import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ppt');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-ppt',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ppt/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
  background: #0a0a0a;
  overflow: hidden;
}

.presentation {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background: #0a0a0a;
  padding-bottom: 36px;
  font-family: "Pretendard", -apple-system, BlinkMacSystemFont, sans-serif;
}

.slide {
  width: min(100vw, (100vh - 36px) * 16 / 9);
  height: min(100vh - 36px, 56.25vw);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 3px;
  box-shadow: 0 2px 24px rgba(0, 0, 0, 0.35);
  background: #f9fafb;
  position: relative;
}

.hbar {
  background: linear-gradient(135deg, #1a2332 0%, #243044 60%, #2a3f5e 100%);
  padding: 14px 40px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-shrink: 0;
}
.hbar .hbar-l {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.hbar .hbar-l .sec-num {
  font-size: 30px;
  font-weight: 800;
  color: white;
  line-height: 1;
}
.hbar .hbar-l .sec-sub {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.55);
  margin-bottom: 2px;
}
.hbar .hbar-l .page-title {
  font-size: 20px;
  font-weight: 700;
  color: white;
  line-height: 1.2;
}
.hbar .hbar-icon {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(59, 130, 246, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #60a5fa;
  font-size: 14px;
  font-weight: 700;
}

.body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 12px 40px 8px;
}

.desc {
  font-size: 11px;
  color: #6b7280;
  margin-bottom: 10px;
  line-height: 1.5;
}

.foot {
  flex-shrink: 0;
  padding: 5px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #e5e7eb;
  background: white;
}
.foot .foot-logo {
  display: flex;
  align-items: center;
  gap: 6px;
}
.foot .foot-logo span {
  font-size: 12px;
  font-weight: 700;
  color: #1f2937;
}
.foot .foot-title {
  font-size: 9px;
  color: #9ca3af;
}

.title-slide {
  flex: 1;
  background: linear-gradient(135deg, #1a2332 0%, #243044 60%, #2a3f5e 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 70px;
  position: relative;
}
.title-slide .ts-logo {
  position: absolute;
  top: 20px;
  left: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.title-slide .ts-logo span {
  color: white;
  font-size: 14px;
  font-weight: 700;
}
.title-slide .ts-tags {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  margin-bottom: 6px;
}
.title-slide .ts-main {
  font-size: 38px;
  font-weight: 800;
  color: white;
  line-height: 1.15;
  margin-bottom: 4px;
}
.title-slide .ts-sub {
  font-size: 30px;
  font-weight: 600;
  color: #60a5fa;
  line-height: 1.15;
  margin-bottom: 14px;
}
.title-slide .ts-bar {
  width: 50px;
  height: 4px;
  background: #3b82f6;
  margin-bottom: 12px;
  border-radius: 2px;
}
.title-slide .ts-desc {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
}
.title-slide .ts-bottom {
  position: absolute;
  bottom: 20px;
  left: 40px;
  right: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title-slide .ts-bottom .ts-badge {
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.6);
}
.title-slide .ts-bottom .ts-date {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  margin-left: 8px;
}
.title-slide .ts-bottom .ts-found {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.5);
}

.toc-slide {
  flex: 1;
  background: linear-gradient(135deg, #1a2332 0%, #243044 60%, #2a3f5e 100%);
  display: flex;
  flex-direction: column;
  position: relative;
}
.toc-slide .toc-head {
  padding: 32px 40px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.toc-slide .toc-head h1 {
  font-size: 28px;
  font-weight: 300;
  color: white;
}
.toc-slide .toc-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 120px;
  gap: 6px;
}
.toc-slide .toc-item {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  padding: 10px 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  border-left: 3px solid #3b82f6;
}
.toc-slide .toc-item .toc-num {
  font-size: 18px;
  font-weight: 700;
  color: #60a5fa;
  min-width: 28px;
}
.toc-slide .toc-item .toc-title {
  font-size: 13px;
  font-weight: 600;
  color: white;
}
.toc-slide .toc-item .toc-sub {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.45);
  margin-top: 1px;
}
.toc-slide .toc-foot {
  padding: 10px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.toc-slide .toc-foot span {
  font-size: 12px;
  font-weight: 700;
  color: white;
}
.toc-slide .toc-foot .toc-ft {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.35);
}

.divider {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.divider .div-top {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
}
.divider .div-top .div-num {
  font-size: 56px;
  font-weight: 800;
  color: #111827;
}
.divider .div-top .div-bar {
  width: 48px;
  height: 4px;
  background: #1a2332;
  margin: 8px 0 10px;
  border-radius: 2px;
}
.divider .div-top .div-title {
  font-size: 26px;
  font-weight: 700;
  color: #111827;
}
.divider .div-bot {
  background: linear-gradient(135deg, #1a2332 0%, #243044 60%, #2a3f5e 100%);
  padding: 20px 40px 32px;
  min-height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.divider .div-bot .div-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
}

.end-slide {
  flex: 1;
  background: linear-gradient(135deg, #1a2332 0%, #243044 60%, #2a3f5e 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}
.end-slide .end-title {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  text-align: center;
  line-height: 1.6;
  margin-bottom: 14px;
}
.end-slide .end-bar {
  width: 60px;
  height: 3px;
  background: #3b82f6;
  margin-bottom: 18px;
  border-radius: 2px;
}
.end-slide .end-main {
  font-size: 42px;
  font-weight: 800;
  color: white;
}
.end-slide .end-logo {
  position: absolute;
  bottom: 28px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.end-slide .end-logo span {
  font-size: 16px;
  font-weight: 700;
  color: white;
}

.req-side {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 10px;
  min-width: 190px;
  max-width: 220px;
  flex-shrink: 0;
}
.req-side .req-title {
  font-size: 11px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 6px;
  padding-bottom: 5px;
  border-bottom: 2px solid #e5e7eb;
}
.req-side .req-item {
  margin-bottom: 6px;
}
.req-side .req-item .req-badge {
  display: inline-block;
  background: #2563eb;
  color: white;
  font-size: 8px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 3px;
  margin-bottom: 2px;
}
.req-side .req-item .req-name {
  font-size: 10px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 1px;
}
.req-side .req-item .req-desc {
  font-size: 9px;
  color: #6b7280;
  line-height: 1.3;
}
.req-side .kpi-bar {
  margin-top: 6px;
  padding-top: 5px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 4px;
}
.req-side .kpi-bar .kpi-b {
  font-size: 7px;
  font-weight: 600;
  padding: 1px 5px;
  border-radius: 3px;
  color: white;
}
.req-side .kpi-bar .kpi-navy {
  background: #1a2332;
}
.req-side .kpi-bar .kpi-blue {
  background: #2563eb;
}
.req-side .kpi-bar .kpi-green {
  background: #22c55e;
}

.card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.card .card-title {
  font-size: 11px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 6px;
}
.card .card-title-bar {
  background: #1f2937;
  color: white;
  font-size: 10px;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 4px 4px 0 0;
  margin: -10px -10px 8px;
}
.card ul {
  list-style: disc;
  padding-left: 14px;
  margin: 0;
}
.card ul li {
  font-size: 9.5px;
  color: #4b5563;
  line-height: 1.5;
  margin-bottom: 1px;
}

.kpi-strip {
  display: flex;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.kpi-strip .kpi-item {
  flex: 1;
  text-align: center;
  padding: 6px 4px;
  border-right: 1px solid #e5e7eb;
}
.kpi-strip .kpi-item:last-child {
  border-right: none;
}
.kpi-strip .kpi-item .kpi-val {
  font-size: 13px;
  font-weight: 800;
  color: #3b82f6;
}
.kpi-strip .kpi-item .kpi-lbl {
  font-size: 8px;
  color: #6b7280;
  margin-top: 1px;
}

.row {
  display: flex;
  gap: 10px;
}

.row-sm {
  display: flex;
  gap: 6px;
}

.col {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.col-sm {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.f1 {
  flex: 1;
  min-width: 0;
}

.f2 {
  flex: 2;
  min-width: 0;
}

.mt-10 {
  margin-top: 8px;
}

.mt-14 {
  margin-top: 10px;
}

.ov-table {
  width: 100%;
}
.ov-table .ov-tr {
  display: flex;
  border-bottom: 1px solid #e5e7eb;
}
.ov-table .ov-th {
  width: 80px;
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 600;
  color: #374151;
  padding: 5px 8px;
  background: #f9fafb;
}
.ov-table .ov-td {
  flex: 1;
  font-size: 10px;
  color: #374151;
  padding: 5px 8px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 9.5px;
}
.data-table th {
  background: #f3f4f6;
  font-weight: 600;
  color: #374151;
  padding: 4px 8px;
  text-align: left;
  border-bottom: 2px solid #d1d5db;
}
.data-table td {
  padding: 4px 8px;
  border-bottom: 1px solid #e5e7eb;
  color: #374151;
}

.scope-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.scope-grid .scope-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.scope-grid .scope-card .sc-head {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}
.scope-grid .scope-card .sc-head .sc-num {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #3b82f6;
  color: white;
  font-size: 9px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.scope-grid .scope-card .sc-head .sc-name {
  font-size: 10px;
  font-weight: 700;
  color: #1f2937;
}
.scope-grid .scope-card .sc-head .sc-tag {
  margin-left: auto;
  font-size: 7px;
  color: #9ca3af;
  border: 1px solid #e5e7eb;
  padding: 1px 4px;
  border-radius: 3px;
}
.scope-grid .scope-card ul {
  list-style: disc;
  padding-left: 14px;
  margin: 0;
}
.scope-grid .scope-card ul li {
  font-size: 9px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 0;
}

.stat-row {
  display: flex;
  gap: 6px;
}
.stat-row .stat-card {
  flex: 1;
  text-align: center;
  padding: 6px 3px;
  background: #1a2332;
  border-radius: 4px;
}
.stat-row .stat-card .stat-num {
  font-size: 15px;
  font-weight: 800;
  color: white;
}
.stat-row .stat-card .stat-lbl {
  font-size: 7px;
  color: rgba(255, 255, 255, 0.65);
  margin-top: 1px;
}

.flow-box {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 6px 10px;
  text-align: center;
}
.flow-box .fb-title {
  font-size: 9px;
  font-weight: 600;
  color: #1f2937;
}
.flow-box .fb-sub {
  font-size: 7.5px;
  color: #6b7280;
  margin-top: 1px;
}

.flow-blue {
  border-color: #3b82f6;
  background: rgba(59, 130, 246, 0.05);
}
.flow-blue .fb-title {
  color: #3b82f6;
}

.flow-arrow {
  font-size: 12px;
  color: #d1d5db;
  display: flex;
  align-items: center;
  padding: 0 1px;
}

.flow-diamond {
  width: 42px;
  height: 42px;
  background: rgba(59, 130, 246, 0.08);
  border: 1px solid #3b82f6;
  transform: rotate(45deg);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4px auto;
}
.flow-diamond span {
  transform: rotate(-45deg);
  font-size: 8px;
  font-weight: 600;
  color: #3b82f6;
  text-align: center;
}

.compare {
  display: flex;
  gap: 10px;
  align-items: stretch;
}
.compare .cmp-col {
  flex: 1;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.compare .cmp-col .cmp-title {
  font-size: 11px;
  font-weight: 700;
  margin-bottom: 6px;
}
.compare .cmp-col .cmp-red {
  color: #ef4444;
}
.compare .cmp-col .cmp-blue {
  color: #3b82f6;
}
.compare .cmp-col ul {
  list-style: disc;
  padding-left: 14px;
  margin: 0;
}
.compare .cmp-col ul li {
  font-size: 9.5px;
  color: #4b5563;
  line-height: 1.5;
  margin-bottom: 2px;
}
.compare .cmp-arrow {
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #d1d5db;
  padding: 0 2px;
}

.cmp-metrics {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}
.cmp-metrics .cm-item {
  flex: 1;
  text-align: center;
  padding: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: white;
}
.cmp-metrics .cm-item .cm-label {
  font-size: 9px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 3px;
}
.cmp-metrics .cm-item .cm-change {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 10px;
}
.cmp-metrics .cm-item .cm-change .cm-old {
  color: #9ca3af;
  text-decoration: line-through;
}
.cmp-metrics .cm-item .cm-change .cm-new {
  color: #3b82f6;
  font-weight: 700;
}
.cmp-metrics .cm-item .cm-bar {
  height: 3px;
  border-radius: 2px;
  background: #e5e7eb;
  margin-top: 4px;
}
.cmp-metrics .cm-item .cm-bar .cm-fill {
  height: 100%;
  border-radius: 2px;
}
.cmp-metrics .cm-item .cm-bar .cm-green {
  background: #22c55e;
}
.cmp-metrics .cm-item .cm-bar .cm-blue {
  background: #3b82f6;
}
.cmp-metrics .cm-item .cm-bar .cm-purple {
  background: #7c3aed;
}
.cmp-metrics .cm-item .cm-note {
  font-size: 7px;
  color: #22c55e;
  margin-top: 2px;
}

.onto-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
}
.onto-grid .onto-card {
  background: rgba(59, 130, 246, 0.05);
  border: 1px solid rgba(59, 130, 246, 0.18);
  border-radius: 6px;
  padding: 8px;
  text-align: center;
}
.onto-grid .onto-card .onto-name {
  font-size: 11px;
  font-weight: 700;
  color: #1a2332;
}
.onto-grid .onto-card .onto-en {
  font-size: 8px;
  color: #6b7280;
}

.onto-props {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
}
.onto-props .prop-item .prop-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 4px;
}
.onto-props .prop-item .prop-name {
  font-size: 10px;
  font-weight: 600;
  color: #1f2937;
}
.onto-props .prop-item .prop-detail {
  font-size: 8px;
  color: #6b7280;
  line-height: 1.3;
  margin-top: 1px;
}

.std-list .std-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  margin-bottom: 2px;
  background: white;
}
.std-list .std-item .std-name {
  font-size: 9px;
  font-weight: 600;
  color: #1f2937;
}
.std-list .std-item .std-desc {
  font-size: 8px;
  color: #6b7280;
}

.agent-grid {
  display: grid;
  gap: 8px;
}
.agent-grid.ag-3 {
  grid-template-columns: repeat(3, 1fr);
}
.agent-grid.ag-2 {
  grid-template-columns: repeat(2, 1fr);
}
.agent-grid .agent-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.agent-grid .agent-card .ac-head {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 4px;
}
.agent-grid .agent-card .ac-head .ac-num {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #3b82f6;
  color: white;
  font-size: 8px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.agent-grid .agent-card .ac-head .ac-title {
  font-size: 10px;
  font-weight: 700;
  color: #1f2937;
}
.agent-grid .agent-card ul {
  list-style: disc;
  padding-left: 12px;
  margin: 0;
}
.agent-grid .agent-card ul li {
  font-size: 9px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 0;
}

.sec-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.sec-grid .sec-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.sec-grid .sec-card .sec-title {
  background: #1f2937;
  color: white;
  font-size: 9.5px;
  font-weight: 600;
  padding: 5px 10px;
}
.sec-grid .sec-card .sec-body {
  padding: 6px 10px;
}
.sec-grid .sec-card .sec-body ul {
  list-style: disc;
  padding-left: 12px;
  margin: 0;
}
.sec-grid .sec-card .sec-body ul li {
  font-size: 9px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 1px;
}

.comp-bar {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  margin-top: 8px;
}
.comp-bar .comp-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 4px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}
.comp-bar .comp-badge .cb-label {
  font-size: 8px;
  font-weight: 700;
  color: white;
  padding: 1px 6px;
  border-radius: 3px;
}
.comp-bar .comp-badge .cb-blue {
  background: #3b82f6;
}
.comp-bar .comp-badge .cb-purple {
  background: #7c3aed;
}
.comp-bar .comp-badge .cb-green {
  background: #22c55e;
}
.comp-bar .comp-badge .cb-amber {
  background: #d97706;
}
.comp-bar .comp-badge .cb-navy {
  background: #1a2332;
}
.comp-bar .comp-badge .cb-desc {
  font-size: 8px;
  color: #4b5563;
}

.test-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}
.test-grid .test-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.test-grid .test-card .tc-title {
  font-size: 11px;
  font-weight: 700;
  color: #3b82f6;
  padding: 8px 10px 0;
}
.test-grid .test-card .tc-desc {
  font-size: 8px;
  color: #6b7280;
  padding: 0 10px;
  margin: 1px 0 4px;
}
.test-grid .test-card .tc-body {
  padding: 0 10px 6px;
}
.test-grid .test-card .tc-body ul {
  list-style: disc;
  padding-left: 12px;
  margin: 0;
}
.test-grid .test-card .tc-body ul li {
  font-size: 9px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 0;
}
.test-grid .test-card .tc-metrics {
  display: flex;
  gap: 4px;
  padding: 4px 10px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
}
.test-grid .test-card .tc-metrics .tc-m {
  font-size: 7px;
  font-weight: 600;
  color: #22c55e;
  background: rgba(34, 197, 94, 0.08);
  padding: 1px 5px;
  border-radius: 3px;
}

.nfr-list .nfr-item {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 4px 0;
  border-bottom: 1px solid #f3f4f6;
}
.nfr-list .nfr-item .nfr-badge {
  flex-shrink: 0;
  width: 32px;
  height: 20px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  font-weight: 700;
  color: white;
}
.nfr-list .nfr-item .nfr-name {
  font-size: 9px;
  font-weight: 600;
  color: #1f2937;
}
.nfr-list .nfr-item .nfr-desc {
  font-size: 8px;
  color: #6b7280;
}

.test-proc {
  display: flex;
  align-items: center;
  gap: 3px;
  margin-top: 8px;
}
.test-proc .tp-step {
  background: #f3f4f6;
  border-radius: 4px;
  padding: 5px 8px;
  text-align: center;
}
.test-proc .tp-step .tp-t {
  font-size: 8px;
  font-weight: 600;
  color: #1f2937;
}
.test-proc .tp-step .tp-d {
  font-size: 7px;
  color: #6b7280;
}
.test-proc .tp-active {
  background: #1a2332;
}
.test-proc .tp-active .tp-t {
  color: white;
}
.test-proc .tp-active .tp-d {
  color: rgba(255, 255, 255, 0.55);
}
.test-proc .tp-arr {
  font-size: 9px;
  color: #d1d5db;
}

.gantt {
  width: 100%;
  border-collapse: collapse;
}
.gantt th {
  font-size: 9px;
  font-weight: 600;
  color: #4b5563;
  padding: 4px;
  text-align: center;
  background: #f9fafb;
  border-bottom: 2px solid #d1d5db;
}
.gantt td {
  padding: 3px 4px;
  border-bottom: 1px solid #f3f4f6;
  font-size: 9px;
  color: #374151;
}
.gantt .gb {
  height: 16px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 7px;
  font-weight: 500;
  color: white;
}
.gantt .gb-blue {
  background: rgba(59, 130, 246, 0.45);
}
.gantt .gb-green {
  background: rgba(34, 197, 94, 0.35);
}
.gantt .gb-purple {
  background: rgba(124, 58, 237, 0.35);
}

.roadmap .rm-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 7px;
}
.roadmap .rm-item .rm-year {
  width: 60px;
  text-align: center;
  flex-shrink: 0;
}
.roadmap .rm-item .rm-year .rm-y {
  font-size: 14px;
  font-weight: 800;
  color: #1a2332;
}
.roadmap .rm-item .rm-year .rm-s {
  font-size: 9px;
  color: #6b7280;
}
.roadmap .rm-item .rm-active {
  background: #3b82f6;
  border-radius: 6px;
  padding: 4px 0;
}
.roadmap .rm-item .rm-active .rm-y {
  color: white;
}
.roadmap .rm-item .rm-active .rm-s {
  color: rgba(255, 255, 255, 0.65);
}
.roadmap .rm-item .rm-content {
  flex: 1;
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: white;
}
.roadmap .rm-item .rm-content .rm-title {
  font-size: 11px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 2px;
}
.roadmap .rm-item .rm-content .rm-desc {
  font-size: 9px;
  color: #6b7280;
  margin-bottom: 4px;
}
.roadmap .rm-item .rm-content .rm-tags {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}
.roadmap .rm-item .rm-content .rm-tags .rm-tag {
  font-size: 7px;
  color: #3b82f6;
  border: 1px solid rgba(59, 130, 246, 0.25);
  background: rgba(59, 130, 246, 0.04);
  padding: 1px 5px;
  border-radius: 6px;
}

.effect-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.effect-grid .effect-card {
  background: rgba(59, 130, 246, 0.03);
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 10px;
  text-align: center;
}
.effect-grid .effect-card .ef-num {
  font-size: 16px;
  font-weight: 800;
  color: #3b82f6;
  margin-bottom: 2px;
}
.effect-grid .effect-card .ef-title {
  font-size: 11px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 3px;
}
.effect-grid .effect-card .ef-desc {
  font-size: 9px;
  color: #6b7280;
  line-height: 1.35;
  margin-bottom: 4px;
}
.effect-grid .effect-card .ef-kpi {
  font-size: 8px;
  color: #3b82f6;
  border: 1px solid rgba(59, 130, 246, 0.25);
  background: rgba(59, 130, 246, 0.04);
  padding: 2px 6px;
  border-radius: 6px;
  display: inline-block;
}

.tool-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.tool-grid .tool-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.tool-grid .tool-card .tool-head {
  font-size: 10px;
  font-weight: 600;
  color: #1f2937;
  padding: 8px 10px 0;
}
.tool-grid .tool-card .tool-body {
  padding: 4px 10px 8px;
}
.tool-grid .tool-card .tool-body ul {
  list-style: disc;
  padding-left: 12px;
  margin: 0;
}
.tool-grid .tool-card .tool-body ul li {
  font-size: 9px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 0;
}

.wf-steps {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-top: 8px;
}
.wf-steps .wf-step {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  background: #f3f4f6;
}
.wf-steps .wf-step .wf-num {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #d1d5db;
  color: white;
  font-size: 7px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wf-steps .wf-step .wf-lbl {
  font-size: 8px;
  color: #4b5563;
}
.wf-steps .wf-active {
  background: #1a2332;
}
.wf-steps .wf-active .wf-num {
  background: #3b82f6;
}
.wf-steps .wf-active .wf-lbl {
  color: white;
}
.wf-steps .wf-arr {
  font-size: 9px;
  color: #d1d5db;
}

.app-tool {
  margin-bottom: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.app-tool .at-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid #e5e7eb;
}
.app-tool .at-head .at-title {
  font-size: 12px;
  font-weight: 700;
  color: #1f2937;
}
.app-tool .at-desc {
  padding: 6px 12px;
  font-size: 9px;
  color: #6b7280;
  line-height: 1.35;
  border-bottom: 1px solid #f3f4f6;
}
.app-tool .at-detail {
  padding: 6px 12px;
}
.app-tool .at-detail .at-row {
  display: flex;
  gap: 8px;
  margin-bottom: 2px;
}
.app-tool .at-detail .at-row .at-label {
  width: 50px;
  flex-shrink: 0;
  font-size: 9px;
  font-weight: 600;
  color: #374151;
}
.app-tool .at-detail .at-row .at-val {
  font-size: 9px;
  color: #4b5563;
}
.app-tool .at-tags {
  padding: 4px 12px;
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  border-top: 1px solid #f3f4f6;
}
.app-tool .at-tags .at-tag {
  font-size: 7px;
  color: #3b82f6;
  border: 1px solid rgba(59, 130, 246, 0.25);
  background: rgba(59, 130, 246, 0.04);
  padding: 1px 5px;
  border-radius: 6px;
}

.ui-mock {
  display: flex;
  gap: 8px;
}
.ui-mock .mock-panel {
  flex: 1;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.ui-mock .mock-panel .mp-head {
  background: #f3f4f6;
  padding: 5px 10px;
  font-size: 10px;
  font-weight: 600;
  color: #1f2937;
}
.ui-mock .mock-panel .mp-body {
  padding: 8px;
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ui-mock .mock-panel .mp-body .mp-ph {
  color: #d1d5db;
  font-size: 9px;
}

.ui-feats {
  display: flex;
  gap: 5px;
  margin-top: 8px;
}
.ui-feats .uf-item {
  flex: 1;
  text-align: center;
  padding: 6px 3px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: white;
}
.ui-feats .uf-item .uf-title {
  font-size: 9px;
  font-weight: 600;
  color: #1f2937;
}
.ui-feats .uf-item .uf-desc {
  font-size: 7px;
  color: #6b7280;
  margin-top: 1px;
}

.placeholder {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.placeholder .ph-text {
  font-size: 14px;
  color: #9ca3af;
  font-weight: 500;
}

.nav-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 36px;
  background: rgba(10, 10, 10, 0.92);
  backdrop-filter: blur(8px);
  padding: 0 24px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.nav-bar .progress-bar {
  flex: 1;
  height: 3px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 2px;
}
.nav-bar .progress-bar .progress-fill {
  height: 100%;
  background: #3b82f6;
  border-radius: 2px;
  transition: width 0.3s;
}
.nav-bar .nav-info {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.55);
  white-space: nowrap;
}
.nav-bar .nav-btn {
  width: 26px;
  height: 26px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
}
.nav-bar .nav-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}
.nav-bar .nav-btn:disabled {
  opacity: 0.25;
  cursor: not-allowed;
}

.overview-grid {
  position: fixed;
  inset: 0;
  z-index: 200;
  background: rgba(0, 0, 0, 0.85);
  padding: 20px;
  overflow: auto;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
}
.overview-grid .ov-item {
  background: #f3f4f6;
  border-radius: 5px;
  padding: 6px;
  cursor: pointer;
  text-align: center;
  transition: transform 0.15s;
  aspect-ratio: 16/9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.overview-grid .ov-item:hover {
  transform: scale(1.05);
}
.overview-grid .ov-item .ov-num {
  font-size: 11px;
  font-weight: 700;
  color: #1a2332;
  margin-bottom: 2px;
}
.overview-grid .ov-item .ov-label {
  font-size: 7px;
  color: #4b5563;
}
.overview-grid .ov-active {
  border: 2px solid #3b82f6;
}`],
})
export class PagePptComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public currentSlide: number = 0;
    public totalSlides: number = 33;
    public showOverview: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        document.addEventListener('keydown', this.handleKey.bind(this));
        await this.service.render();
    }

    public handleKey(e: KeyboardEvent) {
        if (e.key === 'ArrowRight' || e.key === ' ' || e.key === 'PageDown') {
            e.preventDefault();
            this.next();
        } else if (e.key === 'ArrowLeft' || e.key === 'PageUp') {
            e.preventDefault();
            this.prev();
        } else if (e.key === 'Home') {
            e.preventDefault();
            this.goTo(0);
        } else if (e.key === 'End') {
            e.preventDefault();
            this.goTo(this.totalSlides - 1);
        } else if (e.key === 'Escape') {
            e.preventDefault();
            this.showOverview = false;
            this.service.render();
        } else if (e.key === 'o' || e.key === 'O') {
            e.preventDefault();
            this.showOverview = !this.showOverview;
            this.service.render();
        }
    }

    public async next() {
        if (this.currentSlide < this.totalSlides - 1) {
            this.currentSlide++;
            await this.service.render();
        }
    }

    public async prev() {
        if (this.currentSlide > 0) {
            this.currentSlide--;
            await this.service.render();
        }
    }

    public async goTo(index: number) {
        this.currentSlide = index;
        this.showOverview = false;
        await this.service.render();
    }

    public get progress() {
        return ((this.currentSlide + 1) / this.totalSlides) * 100;
    }

    public slideLabels: string[] = [
        '표지',
        '목차',
        '01 사업 개요 및 추진 배경',
        '01 추진 배경 및 필요성',
        '01 재단 보유 데이터 현황',
        '01 사업 범위 및 목표 시스템',
        '01 전체 시스템 아키텍처',
        '02 데이터 수집 · 전처리',
        '02 OCR · NER · 전처리',
        '02 데이터 전처리 상세',
        '02 검색엔진 구축 및 최적화',
        '02 검색엔진 AS-IS / TO-BE',
        '03 AI 에이전트 · 지식그래프',
        '03 지식그래프 온톨로지 설계',
        '03 지식그래프 구축 파이프라인',
        '03 Graph-RAG 멀티스텝 파이프라인',
        '03 AI 에이전트 전체 아키텍처',
        '03 5대 AI 에이전트 상세',
        '04 플랫폼 · UI/UX · 보안',
        '04 데이터 저작도구 플랫폼',
        '04 역사왜곡 모니터링 도구',
        '04 사료 비교·분석 도구',
        '04 연구 보고서 초안 생성 도구',
        '04 2패널 UI/UX 설계',
        '04 보안 체계',
        '04 품질 · 테스트 전략',
        '05 추진 전략 · 기대 효과',
        '05 추진 일정',
        '05 추진 체계 · 인력',
        '05 핵심 KPI',
        '05 기대 효과',
        '05 5개년 로드맵',
        '감사합니다'
    ];
}

export default PagePptComponent;